// extracted by mini-css-extract-plugin
export default {"recos":"X3-z","productCardOverride":"Y3-z","rowHasBadge":"Z3-z"};